import { Userpilot } from 'userpilot'
import config from './config'
import { CurrentCompanyStore } from './stores/CurrentCompanyStore'
import { getUserRoleForCompany } from './utilities/securityRoleHelper'
import { IUserResponse } from '@getgreenline/homi-shared'

export function setupUserpilot() {
  if (!config.userpilot.token) return

  try {
    Userpilot.initialize(config.userpilot.token)
  } catch (e) {
    console.error('[Userpilot] initialize failed', e)
  }
}

export async function identifyUserpilotUser(
  user: IUserResponse,
  companyStore: CurrentCompanyStore,
): Promise<void> {
  if (!config.userpilot.token) return

  const { company } = companyStore

  if (!user?.id) return

  try {
    const companyId = company?.id

    if (companyId) {
      // Ensure dependent data is loaded before building payload counts
      const promisesToAwait = []
      if (!companyStore.securityRoles) promisesToAwait.push(companyStore.getSecurityRoles())
      if (!companyStore.users) promisesToAwait.push(companyStore.getEntityUsers())
      if (!companyStore.locations) promisesToAwait.push(companyStore.getLocations())
      await Promise.all(promisesToAwait)

      const companyPayload = company
        ? {
            id: company.id,
            name: company.name,
            state: company.province,
            number_of_shops: companyStore.locations?.length ?? 0,
            number_of_employees: companyStore.users?.length ?? 0,
          }
        : undefined

      const attrs: Record<string, any> = {
        name: user.name,
        email: user.email,
        ...getUserRoleForCompany(user, companyId, companyStore.securityRoles),
        ...(companyPayload ? { company: companyPayload } : {}),
      }

      Userpilot.identify(user.id, attrs)
    }
  } catch (e) {
    console.error('[Userpilot] identify failed', e)
  }
}

export function reloadUserpilot(): void {
  if (!config.userpilot.token) return
  try {
    Userpilot.reload()
  } catch (e) {
    console.error('[Userpilot] reload failed', e)
  }
}
